export const heartbeatsLinks = {
	'heartbeats-list-description': {
		iphId: '3dSX8RbqPG9NfE5QwdW5ko',
		sacUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-heartbeats/',
	},
	'heartbeats-empty-state': {
		iphId: '3dSX8RbqPG9NfE5QwdW5ko',
		sacUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-heartbeats/',
	},
};
